import { ProductType } from '../types/Product';

export const getProductMinQuantity = (product: ProductType) => {
	const nominalQuantityStr = product?.['x_measurements.nominalQuantity'];

	if (nominalQuantityStr) {
		return Number(nominalQuantityStr);
	}

	return 1;
};
